module.exports = __webpack_public_path__ + "images/c4c1582edbb4a55e87051e4cbb79ec64.png";